import React, { useEffect, useState, useRef } from "react"
import { createPortal } from 'react-dom';

export type ScrimProps = {
    /**  children (text/jsx) to be rendered in component  */
    children?: React.ReactNode;
    /** show scrim or not */
    show?: boolean
    /** callback for when comopnent is mounted or not */
    mounted?: (isMounted: boolean) => void;
    /** onClick event for Scrim only */
    onClick?: (event) => void;
    /** Custom zindex by default 4 */
    customZindex?: number;
}

export const SCRIM_VISIBLE = 'fadein';
export const SCRIM_INVISIBLE = 'fadeout';

export const Scrim = ({
    children,
    show = false,
    mounted = undefined,
    onClick = undefined,
    customZindex = 4
}: ScrimProps) => {

    const [transition, setTransition] = useState(SCRIM_INVISIBLE);
    const [render, setRender] = useState(show);
    const scrimRef = useRef(null);

    useEffect(() => {
        // :( in some cases, this is needed so the browser finalizes an initial state of opacity, react works fine, browser doesn't
        if (show) {
            setRender(true);
            setTimeout(() => {
                setTransition(SCRIM_VISIBLE);
            }, 100);
        }
        return () => {
            document.documentElement.classList.remove("overflow-hidden");
        }
    }, []);

    useEffect(() => {
        if (show) {
            setRender(true);
        }
        setTimeout(() => {
            setTransition(show ? SCRIM_VISIBLE : SCRIM_INVISIBLE);
        }, 100);
    }, [show]);

    const transitionEnd = () => {
        if (transition === SCRIM_INVISIBLE) {
            document.documentElement.classList.remove("overflow-hidden");
            mounted?.(false);
            setRender(false);
        } else {
            document.documentElement.classList.add("overflow-hidden");
            mounted?.(true);
        }
    }

    const modalClass = [
        'bg-rgba-black-85 fixed height-full left top block width-full',
        transition,
    ].join(' ');

    const jsx = (
        render ?
            <div
                ref={scrimRef}
                className={modalClass}
                onTransitionEnd={transitionEnd}
                onClick={(event) => {
                    if (scrimRef?.current === event.target) {
                        onClick?.(event);
                    }
                }}
                style={{zIndex: customZindex}}
            >
                {/*React.Children.map(children, (child, idx) => {
                    if (React.isValidElement(child) && child.type && child.type['allowInScrim'] === true) {
                        return React.cloneElement(child as React.ReactElement<any>, {
                            inScrim: true,
                        });
                    } else {
                        return child;
                    }
                })*/}
                {children}
            </div> : null

    )

    // It is recommended that apps do not set show=true on SSR, although it will work,
    // it is not best practice since the SSR return will not match the client side initialization,
    // in non prod, there will be an error message in the console.log
    return typeof document !== "undefined" ? createPortal(jsx, document.body) : null;

}
